/** Modèle de courrier — garder aligné avec mail.md à la racine du dépôt. */

export const RESILIATION_PF_MAIL_SUBJECT =
  "Demande de résiliation et remboursement du prorata – Contrat d'assurance perte financière";

export const RESILIATION_PF_MAIL_BODY = `Madame, Monsieur,

Je vous adresse la présente afin de solliciter la résiliation de mon contrat d'assurance perte financière.

Conformément aux dispositions de l'article L.113-15-1 du Code des assurances, issu de la loi n°2014-344 du 17 mars 2014 (loi Hamon), tout assuré peut, passé un délai d'un an à compter de la souscription, résilier son contrat à tout moment, sans motif, sans frais ni pénalités. La résiliation prend alors effet un mois après la réception de la présente notification.

Je me prévaux également de l'article L.121-4 du Code des assurances, relatif à la situation de double assurance, qui prévoit que lorsqu'un même risque est couvert par plusieurs assureurs, l'assuré peut dénoncer les contrats redondants. En l'espèce, la garantie perte financière est déjà incluse dans mon contrat d'assurance automobile, rendant le présent contrat sans objet.

Je vous rappelle qu'en application de l'article L.113-16 du Code des assurances, en cas de résiliation en cours d'année, vous êtes tenu de me rembourser la partie de prime correspondant à la période non couverte.

Je vous remercie de bien vouloir confirmer la prise en compte de cette résiliation et de m'indiquer le montant du remboursement auquel j'ai droit.

Cordialement,`;

export function getResiliationPfMailPlainText() {
  return `Subject: ${RESILIATION_PF_MAIL_SUBJECT}\n\n${RESILIATION_PF_MAIL_BODY}`;
}
